<template>
  <div>
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </transition>
    </section>

    <!-- <div @mouseenter="showDetail" @mouseleave="hideDetail">
      测试元素
    </div>
      <div class="animate__animated" :class="{
        'animate__fadeIn': showDetail_,
        'animate__fadeOut': !showDetail_
      }" v-if="showDetail_">
        测试动画效果
      </div> -->

  </div>
</template>
<script>
export default {
  name: "AppMain1",
  data() {

    return {
      showDetail_: false
    }
  },
  mounted() {
    // console.log('AppMain1组件mounted')
    // console.log(this.$route.fullPath)
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  methods: {
    showDetail() {
      this.showDetail_ = true;
    }
    ,
    hideDetail() {
      this.showDetail_ = false;
    }
  }
};
</script>
<style langn="less" scoped>
.app-main {
  overflow: hidden;
  overflow-y: hidden;
}

/* 
  .fade-enter-active 对应元素进入时的动画
  .fade-leave-active 对应元素离开时的动画
*/
.detail-fade-enter-active {
  /* 直接应用 animate.css 的类 */
  animation-name: animate__slideInUp;

  animation-duration: 0.5s;
}

.detail-fade-leave-active {
  animation-name: animate__fadeOut;
  animation-duration: 0.5s;
}
</style>